import { EMAIL_REGEX, GENERAL_FORM_CONSTANTS } from "../../../../constants";
import { FormValidationType } from "../../../../types";
import { SHIPMENT_DETAILS_CONSTANTS } from "../../../constants";

export const formFieldsValidation: FormValidationType = {
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_DETAILS]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_ID]: {
    required: { value: true },
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_NAME]: {
    required: { value: true },
    maxCharacters: { value: 100 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.STANDARD_CARRIER_ALPHA_CODE]: {
    required: { value: true },
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_EMAIL_ADDRESS]: {
    required: { value: true },
    maxCharacters: { value: 100 },
    matchRegExp: {
      value: new RegExp(EMAIL_REGEX),
      message: GENERAL_FORM_CONSTANTS.EMAIL_INVALID_MESSAGE,
    },
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_TYPE]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.TRANSPORTATION_MODE]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.TRAILER_TYPE]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.CMR_RESERVED]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.PNC_TIMELINE_MET]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.VRID_LOAD_ID]: {
    required: { value: true },
    maxCharacters: { value: 100 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.AMAZON_ORDER_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 100 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT_DETAILS]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT]: {
    required: { value: true },
  },
  [SHIPMENT_DETAILS_CONSTANTS.FLIGHT_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 30 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.VESSEL_NAME]: {
    required: { value: false },
    maxCharacters: { value: 100 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.CONTAINER_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 100 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.SHIPMENT_TYPE]: {
    required: { value: true },
  },
  [SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT_OTHER_DESCRIPTION]: {
    required: { value: false },
    maxCharacters: { value: 8000 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DETAILS]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_NUMBER]: {
    required: { value: true },
    maxCharacters: { value: 150 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DATE]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.ORIGINATION_DETAILS]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.LANE_ORIGINATION]: {
    required: { value: true },
    maxCharacters: { value: 50 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_ORIGINATION_CITY]: {
    required: { value: true },
    maxCharacters: { value: 150 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_ORIGINATION_COUNTRY]: {
    required: { value: true },
  },
  [SHIPMENT_DETAILS_CONSTANTS.DESTINATION_DETAILS]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.LANE_DESTINATION]: {
    required: { value: true },
    maxCharacters: { value: 50 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DESTINATION_CITY]: {
    required: { value: true },
    maxCharacters: { value: 150 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DESTINATION_COUNTRY]: {
    required: { value: true },
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARGO_DESCRIPTION]: {
    required: { value: true },
    maxCharacters: { value: 8000 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.SEAL_STATUS]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.INVOICE_DETAILS]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.INVOICE_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 29 },
  },
  [SHIPMENT_DETAILS_CONSTANTS.INVOICE_CURRENCY_CODE]: {
    required: { value: false },
  },
  [SHIPMENT_DETAILS_CONSTANTS.TOTAL_INVOICE_VALUE]: {
    required: { value: false },
    maxCharacters: { value: 20 },
  },
};
